import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter } from 'react-router-dom';
import AppRoutesV2 from "./AppRoutesV2";
import { AuthProvider } from "./AuthProvider";
import App from "./App";


// const history = createHistory();

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);